import {Module} from "vuex-smart-module";

import UtilityCounterState from "@/store/modules/utility-counter/utility-counter-state";

import UtilityCounterGetters from "@/store/modules/utility-counter/utility-counter-getters";

import UtilityCounterMutations from "@/store/modules/utility-counter/utility-counter-mutations";

import UtilityCounterActions from "@/store/modules/utility-counter/utility-counter-actions";

export default new Module({
    state: UtilityCounterState,
    getters: UtilityCounterGetters,
    mutations: UtilityCounterMutations,
    actions: UtilityCounterActions
});